<template>
  <div class="element downloads row">
    <div class="col-6">
      <AssetField name="lesson_asset_id" label="Asset" v-model="asset" :types="['image','video']" />
    </div>
    <div class="col-6">
      <Field type="text" label="Lesson Name" name="lesson_name" v-model="name" />
      <button type="button" role="button" class="btn btn-info mt-3 w-50" @click.prevent="add">Attach</button>
    </div>
    <div v-if="assigned.length > 0" class="col-12 mt-3 multi-assign-values">
      <a v-for="(item, i) in assigned" :key="i" class="pill" href="#" @click.prevent="remove(item)">
        <span class="text">{{ item.name }}</span>
        <icon icon="remove" class="icon" />
        <input type="hidden" :name="`lessons[${i}][asset_id]`" :value="item.asset_id" />
        <input type="hidden" :name="`lessons[${i}][name]`" :value="item.name" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      asset: null,
      name: null,
      assigned: []
    };
  },
  watch: {
    value(val) {
      this.assigned = val;
    },
    assigned(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    isAssigned(item) {
      return this.assigned.find(a => a.asset_id == item.asset_id) || false;
    },
    add() {
      if (!this.asset || !this.name) {
        alert(
          "Please choose an asset and enter a lesson name before continuing."
        );
        return;
      }
      var item = {
        asset_id: this.asset.id,
        name: this.name
      };
      if (this.isAssigned(item)) {
        alert("You have already assigned the selected asset.");
        return;
      }
      this.assigned.push(item);
      this.reset();
    },
    remove(item) {
      let assigned = this.assigned;
      this.assigned = [];
      this.assigned = assigned.filter(a => {
        return a.asset_id != item.asset_id;
      });
    },
    reset() {
      this.asset = null;
      this.name = null;
    }
  },
  mounted() {
    this.assigned = this.value;
  }
};
</script>